import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from "@angular/core";
import { BreadcrumbService } from "@core/services/breadcrumb/breadcrumb.service";
import { RouterLink } from "@angular/router";
import { Breadcrumb } from "@core/services/breadcrumb/breadcrumb.type";
import { TranslationPipeModule, TranslationService } from "@ogs-gmbh/ngx-translate";
import { TemplatePipeModule } from "@ogs-gmbh/ngx-template-engine";
import { NgTemplateOutlet } from "@angular/common";


function getTemplatePlaceholderFromString (value: string): string[] {
  const templatePlaceholder: string[] = [];

  let currentTemplatePlaceholder: string = "";
  let isOpen: boolean = false;

  for (const char of value) {
    if (char === "}" && isOpen && currentTemplatePlaceholder !== "") {
      isOpen = false;
      templatePlaceholder.push(currentTemplatePlaceholder);
    } else if (char === "{")
      isOpen = true;
    else if (isOpen)
      currentTemplatePlaceholder += char;
  }


  return templatePlaceholder;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-core-ui-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrl: "breadcrumb.component.scss",
  standalone: true,
  imports: [ RouterLink,
    TranslationPipeModule,
    TemplatePipeModule,
    NgTemplateOutlet ]

})
export class BreadcrumbComponent implements OnInit {
  private _translationService: TranslationService = inject(TranslationService);

  private readonly breadcrumbService: BreadcrumbService = inject(BreadcrumbService);

  public breadcrumbs: WritableSignal<Breadcrumb[] | undefined> = signal([]);

  getUrl (index: number): string {
    const url: string | undefined = this.breadcrumbs()?.filter((_: Breadcrumb, i: number) => i <= index)
      .map((b: Breadcrumb) => b.segment)
      .join("/");

    return url ?? "";
  }

  public ngOnInit (): void {
    this.breadcrumbService.breadcrumbs$.subscribe((crumbs: Breadcrumb[]) => {
      for (const crumb of crumbs) {
        if (crumb.translationInfo && crumb.replacementObj) {
          this._translationService.translateTokenByCurrentLocale$(crumb.translationInfo.token, crumb.translationInfo.defaultText, crumb.translationInfo.scope)
            .subscribe((translatedValue: string) => {
              if (getTemplatePlaceholderFromString(translatedValue).length === 0)
                crumb.replacementObj = undefined;
            });
        }
      }

      this.breadcrumbs.set([ ...crumbs ]);
    });
  }
}

